/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateInviteRequest } from '../../models/update-invite-request';

export interface ApiInvitesInviteIdPut$Params {
  inviteId: string;
      body?: UpdateInviteRequest
}

export function apiInvitesInviteIdPut(http: HttpClient, rootUrl: string, params: ApiInvitesInviteIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiInvitesInviteIdPut.PATH, 'put');
  if (params) {
    rb.path('inviteId', params.inviteId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiInvitesInviteIdPut.PATH = '/api/Invites/{inviteId}';
